import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Thin wrapper for the standard Admin Save action.
 * Composes app-button with primary variant and shared defaults.
 */
@Component({
  selector: 'app-admin-save-button',
  templateUrl: './admin-save-button.component.html',
  styleUrls: ['./admin-action-button.scss'],
  host: {
    '[class]': 'hostClass',
  },
})
export class AdminSaveButtonComponent {
  /** Host-level layout classes (e.g. float-right, order-1) */
  @Input() hostClass = '';
  /** Translation key for the button label */
  @Input() labelKey = 'admin.global.save';
  /** Optional test id forwarded to the rendered button */
  @Input() dataTestid = 'save-button';
  @Input() disabled = false;
  /** Additional CSS classes for the inner button element */
  @Input() classes = '';
  @Input() type = 'button';
  @Input() startIcon = 'fa-save';
  @Input() size: 'small' | 'medium' | 'large' | 'default' = 'medium';

  @Output() save = new EventEmitter<Event>();

  onClick(event: Event): void {
    this.save.emit(event);
  }
}
